import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../assets/theme/theme";

const componentStyles = () => ({
  pageTitle: {
    margin: "0",
    color: theme.palette.gray[800],
    fontSize: "1rem",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
});

const useStyles = makeStyles(componentStyles);

const CustomTypography = (props) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <Typography
      data-testid="breadcrumbs-text"
      className={classes.pageTitle}
      variant="h1"
    >
      {children}
    </Typography>
  );
};

export default CustomTypography;
